export abstract class CypherGateway {
    abstract EncryptText(text: string): string;
    abstract DecryptText(text: string): string;
    abstract EncryptObject(text: Object): string;
    abstract DecryptObject(text: string): any;
}